module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_10.7756981a7dcfcd976ac8a0c1de773c5e.png";